import React from 'react';

export default ({ color = '#8E95AA', size = 19 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.35462 10.844C5.09791 10.844 5.70046 10.2415 5.70046 9.49818C5.70046 8.75489 5.09791 8.15234 4.35462 8.15234C3.61134 8.15234 3.00879 8.75489 3.00879 9.49818C3.00879 10.2415 3.61134 10.844 4.35462 10.844Z"
      fill={color}
    />
    <path
      d="M9.50013 10.844C10.2434 10.844 10.846 10.2415 10.846 9.49818C10.846 8.75489 10.2434 8.15234 9.50013 8.15234C8.75685 8.15234 8.1543 8.75489 8.1543 9.49818C8.1543 10.2415 8.75685 10.844 9.50013 10.844Z"
      fill={color}
    />
    <path
      d="M14.6456 10.844C15.3889 10.844 15.9915 10.2415 15.9915 9.49818C15.9915 8.75489 15.3889 8.15234 14.6456 8.15234C13.9024 8.15234 13.2998 8.75489 13.2998 9.49818C13.2998 10.2415 13.9024 10.844 14.6456 10.844Z"
      fill={color}
    />
  </svg>
);
